import React, { useState } from 'react'
import { UpperRow } from '../../../../library/upper-row'
import AllChannelsTable from './table'
import { TableLoader } from '../../../../library/table-loader'
import { useSelector } from 'react-redux'
import { changeCompanyModal } from '../../../../../redux/actions/company'
import { useDispatch } from 'react-redux'
import { SolidButton } from '../../../../library/button'
import './style.scss'

const Index = () => {

    const dispatch = useDispatch()
    const channels = useSelector(state => state.company.channels)

    const companyDetailsLoading = useSelector(state => state.company.fetchDetails.loading)

    const loading = useSelector(state => state.company.fetchChannels.loading)

    const clickAddChannel = () => {
        dispatch(changeCompanyModal({addChannel: true}))
    }

    const renderMainButtons = () => {
        if(!companyDetailsLoading && !loading){
            return [
                <SolidButton onClick={() => clickAddChannel()} color="green" icon={<i class="fad fa-plus"></i>} title="Legg til kanal"/>
            ]
        }
        return null
    }

    const renderEmptyView = () => {
      if(!companyDetailsLoading && channels.length === 0){
        return(
            <div className="empty-subscription-container">
                <div className="inner-empty-subscription-container">
                    <h2 className="empty-title highlight">Ingen kanaler satt opp</h2>
                    <p className="empty-description">For å sende ut e-post, sms eller ringe på du først sette opp en kanal for utsending.</p>
                </div>
            </div>
        )
      }
      return null
    }


    return(
        <div className="dashboard-company-channels-container">
            <div className="inner-dashboard-company-channels-container">
                <UpperRow title="Kanaler" buttons={renderMainButtons()}/>
                <AllChannelsTable/>
                {renderEmptyView()}
                {companyDetailsLoading ? <TableLoader/>:null}
            </div>
        </div>
    )
}

export default Index